import { TranslateText } from "../../../../utils/translation";
const Preview = ({ localHotelDetailsState }) => {
  const nearByCategory = localHotelDetailsState?.nearbyAttractions
    ?.map((Obj) => Obj?.type)
    ?.filter((Obj) => Boolean(Obj));

  const displayArray = localHotelDetailsState?.nearbyAttractions?.filter(
    (Obj) => Obj?.type === nearByCategory?.[0]
  );

  return (
    <div className=" flex flex-col gap-[24px]   relative " id="Home">
      <div className="font-body font-[500] text-[24px] leading-[30.24px] text-fg">
        <TranslateText
          textKey={"nearby_places_and_attraction"}
          namespace="profile"
        />
      </div>

      <div className="flex gap-[12px] flex-wrap">
        {nearByCategory?.map((Obj, idx) => {
          return (
            <div
              className={`${
                idx === 0
                  ? "border-[1px] border-primary bg-surface-page text-primary font-[500]"
                  : "border-[1px] border-brand-border-muted bg-brand-border-muted font-[400] text-fg"
              } font-body p-2 rounded-[8px] `}
              key={idx}
            >
              {Obj}
            </div>
          );
        })}
      </div>

      <div className="flex flex-wrap gap-[12px]">
        {displayArray?.map((Obj) => {
          return (
            <div
              key={Obj}
              className="w-[190px] h-[190px] relative rounded-[12px]"
            >
              <img
                src={Obj?.urls?.[0]}
                alt=""
                className="w-[100%] h-[100%] rounded-[12px] absolute "
              />

              <div className="flex flex-col p-2 gap-1 z-[20] absolute bottom-0 w-[100%]">
                <div className="flex justify-between items-center w-[100%]">
                  <div className="font-body font-[500] text-fg-inverse text-[12px]">
                    {Obj?.name}
                  </div>
                  <div className="font-body font-[400] text-fg-inverse text-[12px]">
                    {Obj?.distance}
                  </div>
                </div>

                <div className="font-body font-[300] text-fg-inverse text-[10px] w-[100%]">
                  {Obj?.description}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Preview;
